<div class="login-page container-fluid">
  <div class="row">
    <div class="col">
      <button mat-flat-button color="primary" class="pl-3 pr-3" [disabled]="(isLoading==true)"
        (click)="onRunManualPayment() ">
        {{isLoading?"Running Manual Payment...":"Run Manual Payment"}}
      </button>
    </div>
  </div>
</div>